<div
  class="expander__wrapper"
  [class.expander__wrapper--expanded]="isExpanded"
  [attr.id]="id"
>
  <div>
    <ng-content></ng-content>
  </div>
</div>
